export const APP_ASSISTANT_PORTAL_ID = "tcs-app-assistant-slot";
